import './Calc.scss';
import Header from '../header/header';
import Counter from '../counter/counter';
import Calculator from '../calculator/calculator';
import { Component } from 'react';

class Calc extends Component{
    render() {
        return (
            <div className="Calc">
                <Header />
                <Counter counter={0} />
                <Calculator/>
            </div>
        )
    }
}
export {Calc};
